import React, { Component } from 'react'
import { Button, Icon } from 'react-materialize'

class About extends Component {
  render() {
    return (
      <div style={{ margin: '30px 0' }}>
        <h4>ReactBot Fullstack App</h4>
        <ul>
          <li>FrontEnd: React</li>
          <li>Backend: NodeJs</li>
        </ul>
        <Button waves="light">
          <Icon>thumb_up</Icon>
        </Button>
      </div>
    )
  }
}

export default About
